<template>
  <v-form @submit.prevent="changePassword">
    <div class="elevation-0 pb-3">
      <div class="page__title">
        <h1>Ustal {{ confirmResetText.toLowerCase() }}</h1>
        <title-decoration />
      </div>

      <div class="registerProposition separate--after">
        <p>
          {{ confirmResetText }} musi składać się z minimum 8 znaków (w tym cyfry, znaku specjalnego oraz wielkiej
          litery)
        </p>
      </div>

      <v-card-text class="error-top">
        <w-input
          outlined
          placeholder="********"
          :label="confirmResetText"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          :model="$schema.password"
          @click:append="showPassword = !showPassword"
        />

        <w-input
          outlined
          placeholder="********"
          label="Powtórz hasło"
          :append-icon="showRepeat ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showRepeat ? 'text' : 'password'"
          :model="$schema.repeat"
          @click:append="showRepeat = !showRepeat"
        />
      </v-card-text>

      <v-card-actions>
        <v-btn block elevation="0" large type="submit" color="primary">{{ confirmText }}</v-btn>
      </v-card-actions>
    </div>
  </v-form>
</template>

<script>
import { schemaMixin, WInput } from '@witkac/vuetify-components';
import schema from '@/schemas/confirm.schema';
import TitleDecoration from '@/components/material/TitleDecoration';

// @vuese
// Komponent resetu hasła
// @group Material
export default {
  components: { WInput, TitleDecoration },
  mixins: [schemaMixin],
  schema,
  props: {
    // tytuł komponentu
    title: {
      type: String,
      required: true
    },
    // tekst do wyświetlenia w komponencie
    text: {
      type: String,
      required: false,
      default: ''
    },
    // tekst potwierdzającego przycisku
    confirmText: {
      type: String,
      required: false,
      default: 'Potwierdź'
    }
  },
  data() {
    return {
      model: {
        password: '',
        repeat: ''
      },
      showPassword: false,
      showRepeat: false
    };
  },
  computed: {
    confirmResetText() {
      if (this.$route.name === 'confirm') {
        return 'Hasło';
      }
      return 'Nowe hasło';
    }
  },
  methods: {
    // @vuese
    // Metoda waliduje formularz i zmienia hasło użytkownika
    changePassword() {
      if (!this.$schema.$validateAll().length) {
        // Emituje event do zmiany hasła
        // @arg Zwalidowane hasło
        this.$emit('change', this.model.password);
      }
    }
  }
};
</script>
